import React from 'react';
import { NavLink } from 'react-router-dom';

class AboutCompany extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 bg-white">
                    <div className="container">
                        <div className="section-content ">
                            <div className="m-service-containt text-black">
                                <div className="row">
                                    <div className="col-md-4 col-sm-12">
                                        <div className="service-about-left">
                                            <div className="mt-media">
                                                <img src={require('./../../images/s-1.png')} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-sm-12">
                                        <div className="service-about-right m-b30">
                                            <h3 className="m-t0" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'Bold' }}>نفتخر بعملنا، وجودة ما نقدمه</h3>
                                            <p style={{ fontFamily: 'Cairo, sans-serif', fontSize: '16px', fontWeight: 'light' }}>بناء الأسس للمقاولات تأسست في عام 2008 م ومقرها الرئيسي في الأحساء. تقدم العديد من خدمات التشييد والبناء لجميع المشاريع السكنية والتجارية والحكومية. تهتم بناء الأسس للمقاولات بتقديم خدمات المقاولات العامة بكل احترافية ومصداقية مع جميع
                                                -عملائها وموظفيها وأصحاب المصلحة. كما تلتزم بناء الأسس للمقاولات بإتقان جميع الأعمال التي تقوم بها من خلال الالتزام بتطبيق أعلى المعايير العالمية لتقديم خدمة ذات جودة عالية</p>
                                            <div className="call-for-quote-outer">
                                                <div className="call-quote">
                                                    <span style={{ fontFamily: 'Cairo, sans-serif', fontSize: '16px', fontWeight: 'bold' }}>إتصل بنا</span>
                                                    <h4 style={{ fontFamily: 'Cairo, sans-serif', fontSize: '20px', fontWeight: 'light' }}>+966 920002674</h4>
                                                </div>
                                                <div className="call-estimate bg-dark">
                                                    <h3 style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'light' , color:'white' }}>دقة - جودة - إبداع</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default AboutCompany;